module.exports = __webpack_public_path__ + "img/car_scrappage2.5d1400e4.jpeg";